<template>
  <div>
    <h2 class="mt-6 mb-6">
      {{ machine.serial_number }}
      <br />
      {{ machine.name }}
    </h2>
    <h3 class="mb-3">
      優惠時段設定 (<font color="#FF0000">未設定的時段為平日</font>)
    </h3>

    <div class="text-left">
        <v-btn @click="addWeekday" color="lighten-3" class="mr-3" >新增優惠時段</v-btn>
    </div>

    <v-form>
      <v-card-text>
        <div class="row" v-for="row in weekdayData" v-if="row.delete != true">
          <div class="col-3">
            <v-select
              v-model="row.weekday"
              :items="weekdayList"
              placeholder="選擇星期"
              outlined>
            </v-select>
          </div>
          <div class="col-3">
            <v-text-field
              type="time"
              v-model="row.start_time"
              label="開始時間"
              outlined
            ></v-text-field>
          </div>
          <div class="col-3">
            <v-text-field
              type="time"
              v-model="row.end_time"
              label="結束時間"
              outlined
            ></v-text-field>
          </div>
          <div class="col-2">
            <v-btn @click="delWeekday(row)" color="red" class="mr-3" >刪除</v-btn>
          </div>
        </div>
      </v-card-text>

      <div class="text-center">
        <v-btn @click="dialog = true" color="teal">儲存</v-btn>
      </div>
    </v-form>

    <Confirm @confirm="confirm" :dialog="dialog" title="是否確認儲存？" text />
  </div>
</template>



<script>
import { mapState, mapActions } from "vuex";

import DataMixin from "@/mixins/Data";

import machineApi from "@/api/machine";

import Confirm from "@/components/Confirm";

export default {
  components: {
    Confirm
  },

  mixins: [DataMixin],

  props: ["id"],
  data() {
    return {
      machine: {},
      deals: [],
      weekdayData: [],
      weekdayList: [
        {text: "星期一",value: 1},
        {text: "星期二",value: 2},
        {text: "星期三",value: 3},
        {text: "星期四",value: 4},
        {text: "星期五",value: 5},
        {text: "星期六",value: 6},
        {text: "星期日",value: 0},
      ],
      dialog: false
    };
  },

  computed: {
  },
  watch: {},
  methods: {
    ...mapActions("system", ["set_snackbar"]),

    resHandling(res) {
      this.machine = res.machine;
      this.weekdayData = JSON.parse(JSON.stringify(res.weekdays));

      if(this.weekdayData.length == 0 ){
        this.addWeekday();
      }
    },

    addWeekday(){
      this.weekdayData.push({
        'id': 0,
        'weekday': 1,
        'start_time': '08:00:00',
        'end_time': '12:00:00',
        'delete': false,
      })
    },

    delWeekday(obj){
      obj.delete = true;
    },

    confirm(result) {
      this.dialog = false;
      if (result) {

        let check = true;
        $.each( this.weekdayData, function( key, obj ) {
          if(obj.end_time <= obj.start_time){
            check = false;
          }
        });

        if(check == false){
          this.set_snackbar({
            color: "error",
            text: '結束時間不得小於開始時間'
          });
        }
        else{
          this.submit();
        }
      }
    },

    reset() {
      this.tempData = JSON.parse(JSON.stringify(this.deals));
    },

    submit() {
      machineApi
        .updateWeekdays(this.id, { weekdayData: this.weekdayData })
        .then(res => {
          if (res.status !== 0) {
            this.set_snackbar({
              color: "error",
              text: res.message
            });
          } else {
            this.set_snackbar({
              color: "success",
              text: res.message
            });
            //this.resHandling(res);
          }
        })
        .catch(err => {});
    }
  },

  mounted() {
    machineApi
      .getWeekdays(this.id)
      .then(res => {
        this.resHandling(res);
      })
      .catch(err => {});
  }
};
</script>

<style lang="scss" scoped>
</style>
